import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { MessageSquare, ArrowRight, Sparkles, Zap } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function AgentQuickAccess() {
  // TODO: Replace with actual agent data
  const agentData = {
    lastMessage: "Great progress this week! Let's focus on completing your portfolio project.",
    weeklyFocus: "Building out Task Manager features and learning authentication patterns",
    suggestedAction: "Review OAuth 2.0 documentation before next session"
  };

  return (
    <Card accent className="bg-card shadow-md border-border hover:shadow-lg transition-shadow relative overflow-hidden">
      <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-accent/5 to-transparent rounded-bl-full" />
      <CardHeader className="relative">
        <CardTitle className="text-lg font-bold text-primary flex items-center gap-2">
          <div className="p-1.5 rounded-md bg-accent/10">
            <MessageSquare className="h-5 w-5 text-accent" />
          </div>
          AI Transition Agent
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 relative">
        <div className="p-4 rounded-lg bg-primary/5 border-l-4 border-primary shadow-sm">
          <p className="text-sm text-foreground font-medium italic">"{agentData.lastMessage}"</p>
        </div>
        
        <div className="p-3 rounded-lg bg-muted/30">
          <div className="flex items-start gap-2 mb-1">
            <Zap className="h-4 w-4 text-secondary mt-0.5" />
            <p className="text-xs font-bold text-secondary uppercase tracking-wide">
              This Week's Focus
            </p>
          </div>
          <p className="text-sm text-foreground font-medium ml-6">{agentData.weeklyFocus}</p>
        </div>

        <div className="p-4 rounded-lg bg-secondary/5 border-l-4 border-secondary shadow-sm">
          <div className="flex items-start gap-2">
            <div className="p-1 rounded bg-secondary/10">
              <Sparkles className="h-4 w-4 text-secondary" />
            </div>
            <div>
              <p className="text-xs font-bold text-secondary uppercase tracking-wide mb-1">
                Suggested Action
              </p>
              <p className="text-sm text-foreground font-medium">{agentData.suggestedAction}</p>
            </div>
          </div>
        </div>

        <Button className="w-full bg-primary hover:bg-primary/90 text-primary-foreground shadow-md" asChild>
          <Link to="/transition-agent">
            Open Agent Chat <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
}
